import React, { FC, useMemo } from "react";
import dynamic from "next/dynamic";
import { Props as SnsShareAreaProps } from "../project/SnsShareArea";

const SuzuHead = dynamic(() => import("components/front/custom/sydm2/SuzuHead"));
const SnsShareArea = dynamic<SnsShareAreaProps>(() => import("components/front/project/SnsShareArea"));

// テンプレートリテラルでの動的インポートはnext10で対応できる。それまでは固定switchで対処。
// @see https://github.com/vercel/next.js/issues/4100
const PcCourseButtonBottom: FC<{ projectCode: string; title: string; twitterHashtags: (string | null)[] }> = ({
  projectCode,
  title,
  twitterHashtags,
}) => {
  return useMemo(() => {
    switch (projectCode) {
      case "sydm2":
        return <SuzuHead />;
      default:
        return <SnsShareArea slug={projectCode} title={title} twitterHashtags={twitterHashtags} />;
    }
  }, [projectCode]);
};
export default PcCourseButtonBottom;
